import { useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { send2FaCodeToNumberForPassword } from '@api/userProfile';

import {
	PASSWORD_HISTORY_2FA,
	SEND_CODE_TO_NUMBER_FOR_PASSWORD,
} from '@constants/queryKeys';

export const useMutateSendCodeToNumberForPassword = () => {
	const queryClient = useQueryClient();

	const {
		mutateAsync: sendCodeToNumber,
		isLoading: isLoadingSendCodeToNumber,
	} = useMutation({
		mutationKey: [SEND_CODE_TO_NUMBER_FOR_PASSWORD],
		mutationFn: send2FaCodeToNumberForPassword,
		onSuccess: () => {
			return queryClient.invalidateQueries([PASSWORD_HISTORY_2FA]);
		},
	});

	return {
		sendCodeToNumber,
		isLoadingSendCodeToNumber,
	};
};
